import React, { FC } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './GalleryLightbox.module.scss';

export const GalleryLightboxAd: FC = ({ children }) => {
	return (
		<Modal.Dialog className={styles.galleryLightboxAd}>
			<Modal.Body>{children}</Modal.Body>
		</Modal.Dialog>
	);
};
